import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate,Link, useLocation, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'leaflet/dist/leaflet.css';
import './App.css';
import EntriesList from './EntriesList';
import MapView from './mapView';
import { getAllEntriesGrouped, getAllEntriesGroupedWithoutLogin } from './getAllEntriesGrouped';
import Settings from './Settings';
import LogsHistory from './LogsHistory';
import { fetchUserActionLogs } from './store/slices/userActionLogsSlice';
import { useDispatch } from 'react-redux';
import Analytics from './Analytics';
import AnalyticsOverview from './Pages/AnalyticsOverview';
import { CssBaseline } from "@mui/material";
import logo from './assets/logo.png';
import OpenApp from './OpenApp';
import HomeApp from './HomeApp';
import PrivacyPolicy from './PrivacyPolicy';
import OpenAppCarrier from './OpenAppCarrier';
const website=process.env.REACT_APP_WEBSITE;
const Header = ({ selected,setSelected }) => {
  const navigate = useNavigate();
  const location = useLocation(); // ✅ reactive

  useEffect(() => {
    if (location.pathname === '/') {
      setSelected(null);
    }
  }, [location.pathname]); 
  const tabmenu=[
    {name:'VL Locs',url:'/'},
    {name:'Broker Logs',url:'/logs-history/broker'},
    {name:'Carrier Logs',url:'/logs-history/carrier'},
    {name:'Vnaya Logs',url:'/logs-history/vnaya'}
  ];
  
  return (window.location.pathname!=='/settings' ?<header className="py-1 bg-light shadow sticky-top">
      <div className="container position-relative">
        <div className="row align-items-center justify-content-between">
          <div className="col-md-2 col-3">
            {/* <button
              type="button"
              onClick={() => { navigate('/'); setSelected(null); }}
              className="btn p-0 border-0 bg-transparent"
              style={{ lineHeight: 0 }}
            > */}
              {/* src="https://brokerapi.valueloads.com/images/vlogo.png" */}
              <img
                src={logo}
                alt="Logo"
                style={{ height: '80px', width: 'auto' }}
              />
            {/* </button> */}
          </div>
          <div className={`col-md-10 col-9 d-flex align-items-center`}>
            {!selected ? (<div className="row">
                {tabmenu.map((item) => (
                  <div className="col-lg-3 col-6" key={item.url}>
                    <Link
                      to={item.url}
                      className={`mb-0 text-truncate ${window.location.pathname === item.url ? "activeTab" : "inactiveTab"}`}
                    >
                      {item.name}
                    </Link>
                  </div>
                ))}
              </div>
            ) : (<div className="row">
                <div className='col-10'>
                  <h5 className="text-capitalize mb-0 text-md-center text-wrap fs-12">
                    {selected?.name ? `${selected.name}, ` : ''}{selected?.region ? `${selected.region}, ` : ''} lat: {selected?.lat || '-'}, lng: {selected?.lon || '-'}
                  </h5>
                </div>
                <div className='col-2'>
                  <button onClick={() =>{ navigate('/');setSelected(null);}} className="btn btn-link p-0 text-decoration-none me-md-3 mb-2 mb-md-0">
                    ← Back
                  </button>
                </div>
              </div>
              // <div className="d-flex align-items-center justify-content-between w-100">
              //   <h5 className="text-capitalize mb-0 text-md-center text-wrap fs-12">
              //     {selected.name}, {`${selected.region}`}, lat: {selected.lat}, lng: {selected.lon}
              //   </h5>
              //   <button onClick={() =>{ navigate('/');setSelected(null);}} className="btn btn-link p-0 text-decoration-none me-md-3 mb-2 mb-md-0">
              //     ← Back
              //   </button>
              // </div>
            )}
          </div>
        </div>
      </div>
    </header>:<></>
  );
};

const AppRoutes = ({setSelected}) => {
  const [entries, setEntries] = useState([]);
  const [tab,setTab]=useState(true);
  const [refresh,setRefresh]=useState(true);
  
  const dispatch=useDispatch();
  useEffect(()=>{
    dispatch(fetchUserActionLogs({params: {
      search: undefined,
      userId: undefined,
      platform: null,
      page:1,
      pageSize:50,
    },type:'broker'}));
  },[dispatch]);
  useEffect(() => {
    const fetchData = async () => {
      const data = tab?await getAllEntriesGrouped():await getAllEntriesGroupedWithoutLogin();
      setEntries(data);
    };
    fetchData();
  }, [tab,refresh]);
  return (
    <Routes>
      {website==1 && <>
        <Route path="/" element={<EntriesList entries={entries} tab={tab} refresh={refresh} setTab={setTab} setRefresh={setRefresh}/>} />
        <Route path="/map/:id" element={<MapView entries={entries} setSelected={setSelected}/>} />
        <Route path="/settings" element={<Settings/>} />
        <Route path="/logs-history/:type" element={<LogsHistory users={entries}/>} />
        <Route path="/analytics/:type/:matric" element={<AnalyticsOverview/>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </>}
      {website==2 &&<>
        <Route path="/" element={<HomeApp />} />
        <Route path="/open-app" element={<OpenApp />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </>}
      {website==3 &&<>
        <Route path="/" element={<HomeApp />} />
        <Route path="/open-app-carrier" element={<OpenAppCarrier />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </>}
    </Routes>
  );
};

function App() {
  const [selected, setSelected] = useState(null);
  return (
    <Router>
      <div className="d-flex flex-column vh-100">
        <CssBaseline />
        {website==1 && <Header selected={selected} setSelected={setSelected}/>}
        <main className="overflow-hidden container">
          <AppRoutes setSelected={setSelected} />
        </main>
      </div>
    </Router>
  );
}

export default App;
// "hosting": {
  //   "public": "build",
  //   "ignore": [
  //     "firebase.json",
  //     "**/.*",
  //     "**/node_modules/**"
  //   ],
  //   "rewrites": [
  //     {
  //       "source": "**",
  //       "destination": "/index.html"
  //     }
  //   ]
  // }